import handleEvent from 'utilities/handleEvent';

import styles from './styles.module.scss';

const ActionText = ({ children, className = '', onClick }) => {
    const handleClick = onClick => handleEvent(onClick);

    return (
        <button
            className={`${className} ${styles.actionText}`}
            data-click-type="button"
            onClick={handleClick(onClick)}
        >
            {children}
        </button>
    );
};

export default ActionText;
